




























































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import Menu from '@/components/common/Menu.vue';
import { format } from 'date-fns';
import { dedicatedMachineDetailsService } from '@/components/dedicated-machine-edit/services/DedicatedMachineDetailsService';
import DedicatedMachineDetails from '@/components/new-dedicated-machine/DedicatedMachineDetails.vue';

@Component({
  components: {
    Menu,
    DedicatedMachineDetails,
  },
})
export default class dedicatedMachinesListOperations extends Vue {
  dedicatedMachines = [];
  dedicatedMachinesAll = [];
  nameFilter = '';
  sortBy = 'created_at';
  workspaceId = 0;
  regionId = 0;
  readMore: any = {};
  isLoading: boolean = true;

  formatDate(date: string) {
    return date ? format(new Date(date), 'dd.MM.yyyy') : '';
  }

  @Watch('$route.params.regionId')
  onRegionChange() {
    this.$store.dispatch('dedicatedMachines/getMachines');
    this.regionId = parseInt(this.$route.params.regionId, 10);
  }

  @Watch('nameFilter')
  onNameFilterChanged(name: string) {
    this.dedicatedMachines = this.dedicatedMachinesAll.filter(
      (item: any) => item.name.toLowerCase().indexOf(name.toLowerCase()) > -1
    );
  }

  @Watch('sortBy')
  onSortingChanged(sortBy: string) {
    this.$store.dispatch('dedicatedMachines/sortMachines', sortBy);
  }

  @Watch('$store.state.dedicatedMachines.dedicatedMachines', { immediate: true, deep: true })
  onMachinesChange(data: any) {
    this.dedicatedMachines = this.$store.getters['dedicatedMachines/getMachines'] || [];
    this.dedicatedMachinesAll = this.$store.getters['dedicatedMachines/getMachines'] || [];
    if (data !== false) {
      this.isLoading = false;
    }
  }

  mounted() {
    this.workspaceId = parseInt(this.$route.params.workspaceId, 10);
    this.regionId = parseInt(this.$route.params.regionId, 10);
    this.isLoading = true;
    this.$store.dispatch('dedicatedMachines/getMachines');
  }

  showMore(id: any) {
    this.$set(this.readMore, id, true);
  }
  showLess(id: any) {
    this.$set(this.readMore, id, false);
  }

  powerOff(dedicatedMachineId: any) {
    dedicatedMachineDetailsService
      .powerOffDedicatedMachine(this.workspaceId, this.regionId, dedicatedMachineId)
      .then(() => {
        this.$store.dispatch('dedicatedMachines/getMachines', true);
      });
  }
  powerOn(dedicatedMachineId: any) {
    dedicatedMachineDetailsService
      .powerOnDedicatedMachine(this.workspaceId, this.regionId, dedicatedMachineId)
      .then((data: any) => {
        this.$store.dispatch('dedicatedMachines/getMachines', true);
      });
  }
  restart(dedicatedMachineId: any) {
    dedicatedMachineDetailsService
      .restartDedicatedMachine(this.workspaceId, this.regionId, dedicatedMachineId)
      .then((data: any) => {
        this.$store.dispatch('dedicatedMachines/getMachines', true);
      });
  }
}
